/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedItemTile_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTile_item" | "ProductPhotoItemTile_item">;
    readonly " $refType": "SharedItemTile_item";
};
export type SharedItemTile_item$data = SharedItemTile_item;
export type SharedItemTile_item$key = {
    readonly " $data"?: SharedItemTile_item$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SharedItemTile_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "showSeller",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "isSbTileCarouselTest",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemTile_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isSbTileCarouselTest",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "ProductPhotoItemTile_item",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'dd0f230fbfa7b99f072f513e3dbec023';
export default node;
